(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-transport"] && !Shopify.designMode) return;
  try {
    (function () {
    const cohr = (window.cohr = window.cohr || {});

    /* An Error with the HTTP status on it. The caller cannot choose between "that academy just
       filled" and "something went wrong" without knowing which happened, and a network failure
       arrives as a TypeError with no status at all — which is the third case, and reads as
       `undefined` here on purpose. */
    function CartError(message, status, body) {
      const error = new Error(message);
      error.name = 'CartError';
      error.status = status;
      error.body = body;
      return error;
    }

    /* One parse for both verbs. Shopify answers the basket endpoints with JSON on success and on
       422; anything else — an HTML error page from a proxy, an empty body — is the "unexpected
       response" case and has to reject rather than resolve with nothing, or the caller redirects
       to a cart that was never written. */
    function parse(response) {
      return response
        .json()
        .catch(function () {
          return null;
        })
        .then(function (body) {
          if (!response.ok) {
            const described = body && body.description ? body.description : response.statusText;
            throw CartError(described || 'Cart request failed', response.status, body);
          }
          if (!body) {
            throw CartError('Cart response was not JSON', response.status, null);
          }
          return body;
        });
    }

    function get(url) {
      return fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        /* The basket is a session, so the cookie has to ride along. Same-origin is the default
           in every engine this theme supports; it is stated because the whole module is wrong
           without it and a future edit adding `mode: 'cors'` would quietly drop it. */
        credentials: 'same-origin'
      }).then(parse);
    }

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body || {})
      }).then(parse);
    }

    /* Does the cart hold this code, and does Shopify say it applies? Compared case-insensitively
       because the merchant types the code into a theme setting and Shopify treats codes as
       case-insensitive; a capital letter in Theme settings must not read as a failed booking. */
    function holds(cart, code) {
      const codes = (cart && cart.discount_codes) || [];
      const wanted = String(code).toLowerCase();
      for (let i = 0; i < codes.length; i++) {
        const entry = codes[i] || {};
        if (entry.applicable && String(entry.code || '').toLowerCase() === wanted) return true;
      }
      return false;
    }

    /* Anything at all taking money off by code. The proof for the removal direction: `applicable`
       is what decides whether a code is charging, so an inert leftover is not a failure and a
       live one is. */
    function holdsAny(cart) {
      const codes = (cart && cart.discount_codes) || [];
      for (let i = 0; i < codes.length; i++) {
        if ((codes[i] || {}).applicable) return true;
      }
      return false;
    }

    /* The Attendee's declaration, sent to the cart as the presence or absence of one code, and
       checked against the answer. Both directions matter and neither is the safe one: an
       unsent code overcharges, an unremoved one undercharges, and either way the order stops
       recording what the reader said on the shelf.

       🚨 `discount` ABSENT IS NOT `discount: ''`. Absent leaves the cart's codes alone and sends
       nothing — the shipped state before the code exists in admin, and the state of an academy
       with no add-on. Only a caller that has a declaration to make passes the key at all. */
    function declare(settings) {
      if (typeof settings.discount !== 'string') return Promise.resolve(null);

      return post(settings.updateUrl, { discount: settings.discount }).then(function (cart) {
        const kept = settings.discount ? holds(cart, settings.discount) : !holdsAny(cart);
        if (!kept) {
          /* Its own name rather than a status, because there is no status to give: the request
             succeeded and the cart came back disagreeing with what was asked of it — a code
             misspelled in Theme settings, or deleted in admin. The caller tells the reader the
             fee could not be set and stops; it must never carry on to a cart that says one
             number while the order charges another. */
          const error = CartError('The cart did not take the declaration', undefined, cart);
          error.name = 'DiscountError';
          throw error;
        }
        return cart;
      });
    }

    /* Clear-then-add-then-declare, with the two guards from the header. Written as a promise
       chain rather than async/await to match `form-submit.liquid`, the theme's other network
       module. */
    function book(options) {
      const settings = options || {};
      const wanted = Number(settings.id);
      const quantity = Number(settings.quantity) || 1;

      return get(settings.cartJsUrl).then(function (cart) {
        const items = (cart && cart.items) || [];
        const held = items.length;

        /* Guard 1. Already holding this academy and nothing else: clearing would rewrite a
           Sponsor's places as one. Nothing about the LINE is written and the caller sends them
           to the cart. */
        if (held === 1 && Number(items[0].id) === wanted) {
          /* The declaration goes anyway: the reader may have moved the switch since the line was
             added, and the line is not what records it. */
          return declare(settings).then(function () {
            return { outcome: 'already-held', cart: cart };
          });
        }

        /* Guard 2. A different academy, more than one place held. `item_count` is the total
           quantity across the basket, which under ADR 0001 is that one academy's places. */
        const asks = held > 0 && cart.item_count > 1 && typeof settings.confirm === 'function';

        return Promise.resolve(asks ? settings.confirm(cart) : true).then(function (answer) {
          if (asks && !answer) return { outcome: 'cancelled', cart: cart };

          return post(settings.clearUrl, {})
            .then(function () {
              return post(settings.addUrl, { id: wanted, quantity: quantity });
            })
            /* Declared last, on a cart that now has a line: `applicable: false` on an empty
               cart means nothing, and the answer to this call is the only proof taken. */
            .then(function (added) {
              return declare(settings).then(function () {
                return { outcome: 'booked', item: added };
              });
            });
        });
      });
    }

    cohr.cart = { get: get, post: post, book: book };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dialog"] && !Shopify.designMode) return;
  try {
    (function () {
    const host = document.getElementById('CohrDialog');
    if (!host) return;

    const eyebrow = host.querySelector('[data-dialog-eyebrow]');
    const title = host.querySelector('[data-dialog-title]');
    const body = host.querySelector('[data-dialog-body]');
    const foot = host.querySelector('[data-dialog-foot]');
    const cancelButton = document.getElementById('CohrDialogCancel');
    const confirmButton = document.getElementById('CohrDialogConfirm');
    const closeButton = document.getElementById('CohrDialogClose');

    const cohr = (window.cohr = window.cohr || {});

    let settle = null;

    /* Resolving through one function keeps the promise single-settlement: `close` fires once,
       but so does a replacing call, and both routes land here. */
    function resolve(value) {
      const pending = settle;
      settle = null;
      if (pending) pending(value);
    }

    /* button.liquid puts the visible text in `.button__label`. Reaching for it is a deliberate
       coupling to that snippet's markup, and the alternative — a bare <button> here — would mean
       a second button dialect in the theme. */
    function setButton(button, label) {
      if (label) {
        button.querySelector('.button__label').textContent = label;
        button.hidden = false;
      } else {
        button.hidden = true;
      }
    }

    function open(options) {
      const settings = options || {};

      /* A second call while one is open: the first caller is told it was dismissed rather than
         left waiting on an element that now belongs to someone else. Settling it synchronously
         here is what makes that true — the observer below sees the host already reopened and
         correctly declines to settle the new caller with the old dialog's return value. */
      if (host.open) {
        resolve(null);
        host.close('');
      }

      eyebrow.textContent = settings.eyebrow || '';
      title.textContent = settings.title || '';

      body.textContent = '';
      const paragraphs = Array.isArray(settings.body)
        ? settings.body
        : settings.body
          ? [settings.body]
          : [];
      paragraphs.forEach(function (text) {
        const p = document.createElement('p');
        p.textContent = text;
        body.appendChild(p);
      });

      setButton(cancelButton, settings.cancel);
      setButton(confirmButton, settings.confirm);
      foot.hidden = !settings.cancel && !settings.confirm;

      if (settings.width) {
        host.style.setProperty('--dialog-width', settings.width + 'px');
      } else {
        host.style.removeProperty('--dialog-width');
      }

      host.returnValue = '';
      host.showModal();

      /* The safe button holds focus on an open confirmation — see the doc header. */
      if (!cancelButton.hidden) {
        cancelButton.focus();
      } else {
        closeButton.focus();
      }

      return new Promise(function (done) {
        settle = done;
      });
    }

    /* The close button is not a submitter, so it closes by hand with an empty value — the same
       thing Escape produces. */
    closeButton.addEventListener('click', function () {
      host.close('');
    });

    /* A click whose target is the dialog itself landed on the scrim: every click inside the
       panel targets a descendant. The panel carries all the padding for exactly this reason. */
    host.addEventListener('click', function (event) {
      if (event.target === host) host.close('');
    });

    /* One watcher for every route out — the two submitters, the close button, Escape and the
       scrim. `returnValue` is what tells them apart, and an empty one is a dismissal.

       THIS WATCHES THE `open` ATTRIBUTE. IT MUST NOT GO BACK TO THE `close` EVENT.

       `close` is the obvious thing to listen for and it does not fire: Chrome 151 dispatches
       `cancel` on an Escape dismissal and never dispatches `close`, on this element or on a
       bare one, for a form submission or for a programmatic `.close()` alike. Verified by #14
       on 17 August 2026 from a listener in the page's own world, so it is the browser and not
       the tooling. The dialog opened, closed and set `returnValue` correctly the whole time —
       only the promise never settled, so every `await window.cohr.dialog(...)` hung for ever
       and the caller's next line never ran. Nothing reported it and nothing looked wrong.

       The platform still carries "which button" the same way; we just read it one step later.
       `returnValue` is assigned before `open` is removed, and a MutationObserver callback is a
       microtask after that mutation, so it is always in place by the time this runs.

       The `host.open` guard is what replaces the old `ignoreNextClose` flag: a superseding
       call closes and reopens synchronously, so by the time this fires the host is open again
       and there is nothing to settle — that caller was already resolved by `open` itself. */
    new MutationObserver(function () {
      if (host.open) return;
      resolve(host.returnValue || null);
    }).observe(host, { attributes: true, attributeFilter: ['open'] });

    cohr.dialog = open;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-submit"] && !Shopify.designMode) return;
  try {
    (function () {
    /* The Worker chosen in issue #31. One origin for all nine forms — a second copy of this
       string is how two of them end up pointing at different deployments. */
    const ORIGIN = 'https://forms.houseofcohr.com';
    const SUBMIT_URL = ORIGIN + '/submit';
    const TOKEN_URL = ORIGIN + '/token';

    /* The control shells that can carry an --invalid variant. `closest` matches the element
       itself, so a textarea — which is a single element, not a wrapper plus a control — is found
       by the same call as an input. `checkbox` is here because `form-checkbox` paints
       `.checkbox--invalid` the same way and a required consent box is a real failure state; the
       class name and the variant line up, so nothing else has to know. */
    const SHELLS = ['input', 'select', 'textarea', 'checkbox'];

    const enhanced = new WeakSet();

    /* One token per page, requested on first interaction. See the doc header for why not on load.
       A failed request clears the cache so the submit path retries rather than inheriting a null. */
    let tokenRequest = null;

    /* Resolves to { value, readyAt }: the token, and the clock reading before which a send would
       be refused as too fast. See the doc header. `performance.now()` because the wall clock can
       jump; the Worker's own clock is never compared with this one. */
    function token() {
      if (!tokenRequest) {
        tokenRequest = fetch(TOKEN_URL, { method: 'GET', mode: 'cors', credentials: 'omit' })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .then(function (body) {
            if (!body || !body.token) return null;
            const floor = Number(body.floor_ms) || 0;
            return { value: body.token, readyAt: performance.now() + floor };
          })
          .catch(function () {
            tokenRequest = null;
            return null;
          });
      }
      return tokenRequest;
    }

    function shellOf(control) {
      for (let i = 0; i < SHELLS.length; i++) {
        const found = control.closest('.' + SHELLS[i]);
        if (found) return { element: found, base: SHELLS[i] };
      }
      return null;
    }

    /* Everything the browser will validate, minus the honeypot — which is never required and
       whose value is the Worker's business, not this module's. */
    function validatable(form) {
      return Array.prototype.filter.call(form.elements, function (element) {
        return (
          element.willValidate &&
          element.type !== 'hidden' &&
          element.type !== 'submit' &&
          !element.closest('.form-trap')
        );
      });
    }

    function labelOf(control) {
      /* Two shapes, because a checkbox owns its own label instead of sitting inside a
         `form-field` (`docs/CONVENTIONS.md` §10.1's one exception). Without the second half a
         required consent box arrives in the summary as a bare sentence with nothing naming it,
         in a list where every other line is named — which is the line the reader most needs to
         recognise. */
      const field = control.closest('.form-field');
      const box = field ? null : control.closest('.checkbox');
      let label = null;
      if (field) label = field.querySelector('.form-field__label');
      if (box) label = box.querySelector('.checkbox__label');
      /* The required marker is aria-hidden decoration and has no business in a message. */
      return label ? label.textContent.replace('*', '').trim() : '';
    }

    /* Our own words where we have them, the browser's where we do not. Both are better than a
       generic sentence for a case we did not anticipate. */
    function messageOf(form, control) {
      if (control.validity.valueMissing && form.dataset.cohrMissing) {
        return form.dataset.cohrMissing;
      }
      if (control.validity.typeMismatch && control.type === 'email' && form.dataset.cohrInvalidEmail) {
        return form.dataset.cohrInvalidEmail;
      }
      return control.validationMessage;
    }

    function summaryOf(form) {
      return document.getElementById(form.id + '-errors');
    }

    function markField(control, message) {
      const shell = shellOf(control);
      if (shell) shell.element.classList.toggle(shell.base + '--invalid', Boolean(message));

      if (message) {
        control.setAttribute('aria-invalid', 'true');
      } else {
        control.removeAttribute('aria-invalid');
      }

      const slot = document.getElementById(control.id + '-error');
      if (slot) {
        slot.textContent = message || '';
        slot.hidden = !message;
      }

      /* form-field's rule is that an error replaces the hint — two lines of guidance under a
         failed field is noise at the moment the reader has least patience for it. */
      const hint = document.getElementById(control.id + '-hint');
      if (hint) hint.hidden = Boolean(message);
    }

    function clear(form) {
      validatable(form).forEach(function (control) {
        markField(control, '');
      });

      const summary = summaryOf(form);
      if (!summary) return;
      summary.hidden = true;
      summary.querySelector('.form-errors__list').textContent = '';
      const fallback = summary.querySelector('[data-form-errors-fallback]');
      if (fallback) fallback.hidden = true;
    }

    /* `entries` is [{ id, label, message }]. `serverSide` decides whether the fallback address
       shows: a 500 earns it, a missing surname does not (issue #32 §3). */
    function report(form, entries, serverSide) {
      const summary = summaryOf(form);
      if (!summary) return;

      const list = summary.querySelector('.form-errors__list');
      list.textContent = '';

      entries.forEach(function (entry) {
        const item = document.createElement('li');
        item.className = 'form-errors__item';

        /* An anchor, so the summary is a way back to the field and not just a report about it. */
        const target = entry.id ? document.createElement('a') : document.createElement('span');
        if (entry.id) target.setAttribute('href', '#' + entry.id);
        target.textContent = entry.label ? entry.label + ': ' + entry.message : entry.message;

        item.appendChild(target);
        list.appendChild(item);
      });

      const fallback = summary.querySelector('[data-form-errors-fallback]');
      if (fallback) fallback.hidden = !serverSide;

      summary.hidden = false;
      /* The focus move is what announces this. form-errors deliberately has no live-region role;
         with one, every failure would be announced twice. */
      summary.focus();
    }

    function enhance(form) {
      if (enhanced.has(form)) return;
      enhanced.add(form);

      const gated = 'cohrGate' in form.dataset;
      let busy = false;

      function submitButton() {
        return form.querySelector('button[type="submit"]');
      }

      /* The button ships `disabled` from Liquid and the module turns it on. With JavaScript off
         there is no endpoint at all (ADR 0005), so a form that cannot be submitted is the honest
         state — and it stops the browser's default GET submit reloading the page with the
         enquiry in the query string. The `<noscript>` block above is the way out. */
      function activate() {
        const button = submitButton();
        if (button) button.disabled = false;
      }

      function applyGate() {
        if (!gated || busy) return;
        const button = submitButton();
        if (!button) return;
        const unfilled = validatable(form).some(function (control) {
          if (!control.required) return false;
          /* A tick box is empty when it is unticked, and `value` cannot tell you that: it reads
             the `value` *attribute* whether or not the box is checked, so a consent box with a
             wire value — every one in this theme has one — looks filled from the moment it
             renders. The waiver (#73) is the first gated form with a required box, and without
             this its button would unlock before anything had been signed. */
          if (control.type === 'checkbox' || control.type === 'radio') return !control.checked;
          return control.value.trim() === '';
        });
        button.disabled = unfilled;
      }

      function send() {
        busy = true;

        const button = submitButton();
        const label = button ? button.querySelector('.button__label') || button : null;
        const resting = label ? label.textContent : '';

        if (button) button.disabled = true;
        if (label && form.dataset.cohrBusy) label.textContent = form.dataset.cohrBusy;
        form.setAttribute('aria-busy', 'true');

        token()
          .then(function (issued) {
            /* Hold a send that is sooner than the floor allows, rather than post it to be refused.
               The button already reads busy, so the wait is the ordinary one. */
            const wait = issued ? issued.readyAt - performance.now() : 0;
            if (wait <= 0) return issued;
            return new Promise(function (resolve) {
              setTimeout(function () {
                resolve(issued);
              }, wait);
            });
          })
          .then(function (issued) {
            const payload = {};
            new FormData(form).forEach(function (value, key) {
              payload[key] = value;
            });
            if (issued) payload.token = issued.value;

            return fetch(SUBMIT_URL, {
              method: 'POST',
              mode: 'cors',
              credentials: 'omit',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload)
            });
          })
          .then(function (response) {
            return response
              .json()
              .catch(function () {
                return {};
              })
              .then(function (body) {
                /* Both halves matter. A 2xx carrying `ok: false` is still a failure, and a
                   non-2xx with no body still has to say something. */
                if (!response.ok || body.ok !== true) {
                  const refused = new Error(body.message || form.dataset.cohrFailed || '');
                  /* Marked, because the catch below cannot otherwise tell a sentence we chose
                     from an exception we did not. A network `TypeError` arrives with the message
                     "Failed to fetch", which is truthy, English-only, and no use to a reader —
                     showing it verbatim is the bug this flag exists to prevent. */
                  refused.shown = true;
                  throw refused;
                }
                return body;
              });
          })
          .then(function (body) {
            /* Announced before either surface is chosen, so a section that owns what happens
               next hears it whichever surface it uses. Cancelling keeps the reader's answers —
               see THE SUBMITTED EVENT in the header. The Worker's answer rides along as
               `detail.response`, which is how a server-scored test hears its verdict. */
            const done = new CustomEvent('cohr:submitted', {
              bubbles: true,
              cancelable: true,
              detail: { response: body }
            });
            form.dispatchEvent(done);

            /* The panel surface, for a form that cannot honestly be submitted twice. Hiding the
               form is what stops a second acceptance; the focus move is what announces the
               first, because the button focus was inside the half just hidden. See THE SUCCESS
               SURFACE in the header. */
            const panelId = form.dataset.cohrSuccessPanel;
            const panel = panelId ? document.getElementById(panelId) : null;
            if (panel) {
              form.hidden = true;
              panel.hidden = false;
              (panel.querySelector('[data-cohr-success-focus]') || panel).focus();
              return;
            }

            /* Never fired at script-init time — this is a network response, which is the whole
               reason toast.liquid's ordering trap cannot bite here. */
            if (window.cohr && window.cohr.toast) {
              window.cohr.toast({ message: form.dataset.cohrSuccess, tone: 'success' });
            }
            /* Emptying the form is right for an enquiry — the next one is a new one — and wrong
               for a second attempt at the same task, which is what the knowledge check's Try
               Again is. The listener that took the answers over says so by cancelling. */
            if (!done.defaultPrevented) form.reset();
            clear(form);
          })
          .catch(function (error) {
            const message = error && error.shown ? error.message : form.dataset.cohrOffline || '';
            report(form, [{ id: '', label: '', message: message }], true);
          })
          .then(function () {
            busy = false;
            if (button) button.disabled = false;
            if (label) label.textContent = resting;
            form.removeAttribute('aria-busy');
            applyGate();
          });
      }

      form.addEventListener(
        'focusin',
        function () {
          token();
        },
        { once: true }
      );

      activate();
      if (gated) {
        form.addEventListener('input', applyGate);
        applyGate();
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        /* A boolean, not the button's `disabled` attribute: a second submit can be dispatched
           between the click and the attribute landing, and the attribute alone races. */
        if (busy) return;

        clear(form);

        const failures = [];
        validatable(form).forEach(function (control) {
          if (control.checkValidity()) return;
          const message = messageOf(form, control);
          markField(control, message);
          failures.push({ id: control.id, label: labelOf(control), message: message });
        });

        if (failures.length) {
          report(form, failures, false);
          return;
        }

        /* The seam for a rule the browser cannot express — see THE VALIDATE EVENT in the
           header. It fires only once the native checks have passed, which is what puts a
           missing surname ahead of a page's own rule in the summary rather than beside it. */
        const extra = [];
        form.dispatchEvent(
          new CustomEvent('cohr:validate', {
            detail: {
              fail: function (message, id, label) {
                extra.push({ id: id || '', label: label || '', message: message });
              }
            }
          })
        );

        if (extra.length) {
          report(form, extra, false);
          return;
        }

        send();
      });
    }

    function init() {
      document.querySelectorAll('form[data-cohr-form]').forEach(enhance);
    }

    init();
    /* The theme editor swaps a section's markup without reloading, which would otherwise leave
       the new form inert. The WeakSet makes re-running free on every form that survived. */
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["knowledge-check"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Everything this module knows about the questions it reads out of the DOM: how many there
       are, which section each belongs to, and which option is right. Nothing is written down a
       second time here — see EVERY VALUE IS DECLARED ONCE in the snippet's header. */
    const initialised = new WeakSet();

    function chosen(question) {
      return question.querySelector('input[type="radio"]:checked');
    }

    /* `%count%`-style substitution, because a script block cannot call the `t` filter and the
       sentences arrive as data. `split`/`join` rather than `replace`, which would substitute
       only the first marker — and the score sentence names two numbers. A value that is not
       known is skipped rather than printed as "null", so a server-scored test with no pass mark
       leaves its sentence alone. */
    function fill(template, values) {
      return Object.keys(values).reduce(function (text, key) {
        if (values[key] === null || values[key] === undefined) return text;
        return text.split('%' + key + '%').join(String(values[key]));
      }, template || '');
    }

    function setup(root) {
      if (initialised.has(root)) return;
      initialised.add(root);

      const form = root.querySelector('.knowledge-check__form');
      const result = root.querySelector('.knowledge-check__result');
      if (!form || !result) return;

      const questions = Array.prototype.slice.call(form.querySelectorAll('.knowledge-question'));
      const groups = Array.prototype.slice.call(form.querySelectorAll('.knowledge-check__group'));
      if (!questions.length) return;

      const total = questions.length;
      /* See WHO SCORES in the header. A server-scored test never tallies, so the one place a
         fallback pass mark could decide anything is the browser's. */
      const serverScored = root.dataset.scoring === 'server';
      const passMark = parseInt(root.dataset.passMark, 10) || (serverScored ? null : 70);

      const countEl = root.querySelector('[data-knowledge-count]');
      const remainingEl = root.querySelector('[data-knowledge-remaining]');
      const track = root.querySelector('.knowledge-check__rail-bar .progress-bar__track');
      const bar = root.querySelector('.knowledge-check__rail-bar .progress-bar__fill');
      const breakdown = root.querySelector('[data-knowledge-breakdown]');
      const verdicts = root.querySelectorAll('[data-knowledge-verdict]');
      const retry = root.querySelector('.knowledge-check__retry');

      function answered() {
        return questions.filter(chosen).length;
      }

      /* The rail, the bar's own `aria-value*` triple and the line under the submit button are
         three readings of one number, so they are written in one place. */
      function refresh() {
        const done = answered();
        const percent = Math.round((done / total) * 100);
        const text = fill(root.dataset.answered, { count: done, total: total });

        if (countEl) countEl.textContent = text;
        if (bar) bar.style.setProperty('--progress-bar-fill', percent + '%');
        if (track) {
          track.setAttribute('aria-valuenow', String(percent));
          /* The sentence, not "62 percent" — `progress-bar`'s header makes the same point about
             what the figure means to a reader. */
          track.setAttribute('aria-valuetext', text);
        }
        if (remainingEl) {
          remainingEl.textContent =
            done === total
              ? root.dataset.remainingNone
              : fill(root.dataset.remaining, { count: total - done });
        }
      }

      /* The browser scorer. The answer key is `data-correct` on the radio and the section ranges
         are the DOM's nesting, so this counts and never consults a table. A flat test has no
         groups and is counted as one list. Its result is a verdict in the same shape
         `cohr:verdict` takes, so there is one `reveal` whoever scored. */
      function tally() {
        function right(question) {
          const pick = chosen(question);
          return pick && pick.hasAttribute('data-correct');
        }

        const sections = groups.map(function (group) {
          const items = Array.prototype.slice.call(group.querySelectorAll('.knowledge-question'));
          const title = group.querySelector('.knowledge-check__group-title');
          return {
            name: title ? title.textContent.trim() : '',
            total: items.length,
            correct: items.filter(right).length
          };
        });

        const correct = questions.filter(right).length;
        const percent = Math.round((correct / total) * 100);

        return {
          sections: sections,
          correct: correct,
          total: total,
          percent: percent,
          passed: percent >= passMark
        };
      }

      function reveal(verdict) {
        const outOf = verdict.total || total;
        const percent =
          typeof verdict.percent === 'number'
            ? verdict.percent
            : Math.round((verdict.correct / outOf) * 100);
        const scoreText = fill(root.dataset.score, {
          count: verdict.correct,
          total: outOf,
          pct: percent + '%',
          mark: passMark === null ? null : passMark + '%'
        });

        Array.prototype.forEach.call(verdicts, function (panel) {
          panel.hidden = panel.dataset.knowledgeVerdict !== (verdict.passed ? 'pass' : 'fail');
          const slot = panel.querySelector('[data-knowledge-score]');
          if (slot) slot.textContent = scoreText;
        });

        /* Only a grouped test renders the breakdown's list — see THE CALLER'S MARKUP. */
        if (breakdown) {
          breakdown.textContent = '';
          (verdict.sections || []).forEach(function (section) {
            const row = document.createElement('div');
            row.className = 'knowledge-check__breakdown-row';
            /* The same pass mark the verdict used. A section is weak by the rule the paper is
               marked by, never by a second threshold typed in beside it. */
            if (passMark !== null && Math.round((section.correct / section.total) * 100) < passMark) {
              row.classList.add('knowledge-check__breakdown-row--weak');
            }

            const name = document.createElement('span');
            name.className = 'knowledge-check__breakdown-name';
            name.textContent = section.name;

            const value = document.createElement('span');
            value.className = 'knowledge-check__breakdown-value';
            value.textContent = fill(root.dataset.row, {
              count: section.correct,
              total: section.total
            });

            row.appendChild(name);
            row.appendChild(value);
            breakdown.appendChild(row);
          });
        }

        form.hidden = true;
        result.hidden = false;
        /* The focus move is what announces the score, because the button that was focused is
           inside the form just hidden. It also brings the banner into view — the reader is at
           the foot of a long page — which is why nothing here scrolls by hand. */
        result.focus();
      }

      form.addEventListener('change', function (event) {
        if (!event.target || event.target.type !== 'radio') return;
        /* A question stops being a failure the moment it is answered, not at the next submit. */
        const question = event.target.closest('.knowledge-question');
        if (question) question.classList.remove('knowledge-question--unanswered');
        refresh();
      });

      /* Fired by `form-submit` once name and email have passed, which is what puts them first
         and the questions second. See THE GAP RULE in the header for why this is not one
         `required` radio group per question. */
      form.addEventListener('cohr:validate', function (event) {
        const gaps = questions.filter(function (question) {
          return !chosen(question);
        });

        questions.forEach(function (question) {
          question.classList.toggle('knowledge-question--unanswered', gaps.indexOf(question) !== -1);
        });

        if (gaps.length) {
          const first = gaps[0].querySelector('input[type="radio"]');
          const template = gaps.length === 1 ? root.dataset.gapsOne : root.dataset.gapsMany;
          /* One counted sentence, anchored to the first gap so the summary is a way back to it
             and not just a report about it. */
          event.detail.fail(fill(template, { count: gaps.length }), first ? first.id : '');
          return;
        }

        if (serverScored) return;

        /* Agreed to send, so the verdict is now true of something. Stamped here rather than on
           every change: a partial score sitting in a hidden field half way down the page is a
           number that is true of nothing. */
        const outcome = tally();
        if (form.elements.score) {
          form.elements.score.value = outcome.correct + '/' + total + ' (' + outcome.percent + '%)';
        }
        if (form.elements.result) {
          form.elements.result.value = outcome.passed ? 'PASS' : 'FAIL';
        }
      });

      form.addEventListener('cohr:submitted', function (event) {
        /* Cancelling keeps the answers. `form-submit` would otherwise empty the form for a
           fresh submission, which is right for an enquiry and wrong for a second attempt at
           this — see THE SUBMITTED EVENT in that snippet's header. */
        event.preventDefault();
        if (!serverScored) {
          reveal(tally());
          return;
        }
        /* A server-scored test reveals the Worker's verdict, carried on the 200 that delivered
           the attempt, and nothing else. Checked for shape rather than trusted: an answer with
           no verdict in it shows no score screen — the toast still says the attempt arrived,
           which is true — because a screen drawn from anything else would be one the Worker
           never agreed to. */
        const response = event.detail && event.detail.response;
        const verdict = response && response.verdict;
        if (
          verdict &&
          typeof verdict.correct === 'number' &&
          typeof verdict.total === 'number' &&
          typeof verdict.passed === 'boolean'
        ) {
          reveal({ correct: verdict.correct, total: verdict.total, passed: verdict.passed });
        }
      });

      /* The seam for a verdict this page did not compute — see WHO SCORES in the header. */
      form.addEventListener('cohr:verdict', function (event) {
        if (event.detail) reveal(event.detail);
      });

      if (retry) {
        retry.addEventListener('click', function () {
          /* Nothing is cleared. The reader corrects the answers they got wrong and sends again;
             the score screen is rebuilt from the next verdict. */
          result.hidden = true;
          form.hidden = false;
          form.focus();
        });
      }

      refresh();
    }

    function init() {
      document.querySelectorAll('.knowledge-check').forEach(setup);
    }

    init();
    /* The theme editor swaps a section's markup without reloading the page, which would
       otherwise leave the new rail inert. The WeakSet makes re-running free. */
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["order-field"] && !Shopify.designMode) return;
  try {
    (function () {
    /* The one parameter name every onboarding link carries. A second spelling is a second
       chance for a link to arrive with nothing in the field. */
    const ORDER = 'order';
    const ORDER_MAX = 32;

    /* The person's details, read only on a page that sends no referrer — see THE PERSON'S
       DETAILS in the header. Parameter name and wire name are the same string, on purpose: one
       name Matt types, one name the Worker reads. */
    const PERSON = ['first_name', 'last_name', 'email'];

    function personal() {
      return document.querySelector('meta[name="referrer"][content="no-referrer"]') !== null;
    }

    /* The raw, undecoded value of one parameter, or null. `URLSearchParams` turns `+` into a
       space, which is right for a name and never right for an email address — no address
       contains a space and plenty contain a `+`. So the email is decoded with
       `decodeURIComponent`, which leaves `+` alone and still honours `%2B`. */
    function raw(search, name) {
      const pairs = search.replace(/^\?/, '').split('&');
      for (let i = 0; i < pairs.length; i++) {
        const at = pairs[i].indexOf('=');
        const key = at === -1 ? pairs[i] : pairs[i].slice(0, at);
        if (key === name) return at === -1 ? '' : pairs[i].slice(at + 1);
      }
      return null;
    }

    function read(params, name) {
      if (name === 'email') {
        const value = raw(window.location.search, name);
        if (value !== null) {
          try {
            return decodeURIComponent(value);
          } catch (error) {
            /* A stray `%` that starts no escape. Fall through to the ordinary reading. */
          }
        }
      }
      return params.get(name);
    }

    /* By wire name, not by class: `form-input`'s `class` lands on the shell around the control,
       not on the control itself — a selector aimed at the shell would set `.value` on a `<div>`
       and fail silently. The names are the Worker's and do not move. */
    function write(name, value) {
      document.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
        /* Never over what someone typed. See IT FILLS AN EMPTY FIELD ONLY. */
        if (input.value !== '') return;
        input.value = input.maxLength > 0 ? value.slice(0, input.maxLength) : value;
      });
    }

    /* Out of the address bar once read, so the details are not left in history, a bookmark, a
       screenshot or a copied link. Only the parameters this module owns: anything else on the
       link — `?attendee=`, a campaign tag — is someone else's to read. */
    function strip(params, names) {
      let changed = false;
      names.forEach(function (name) {
        if (params.has(name)) {
          params.delete(name);
          changed = true;
        }
      });
      if (!changed) return;

      const query = params.toString();
      const url = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
      try {
        window.history.replaceState(window.history.state, '', url);
      } catch (error) {
        /* The fields are filled either way; a browser refusing the rewrite leaves the link as it
           arrived, which is what every page did before this module stripped anything. */
      }
    }

    function fill() {
      let params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (error) {
        return;
      }

      const order = params.get(ORDER);
      if (order) {
        /* `#1234` and `1234` are the same order. Nothing else is inferred — see the header. */
        const value = order.trim().replace(/^#/, '').slice(0, ORDER_MAX);
        if (value) write('order_number', value);
      }

      if (!personal()) return;

      PERSON.forEach(function (name) {
        const value = read(params, name);
        if (value && value.trim()) write(name, value.trim());
      });

      strip(params, [ORDER].concat(PERSON));
    }

    fill();
    document.addEventListener('shopify:section:load', fill);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    (function () {
    const host = document.getElementById('ToastHost');
    const template = document.getElementById('ToastTemplate');
    if (!host || !template) return;

    const TONES = ['neutral', 'success', 'danger'];
    const DEFAULT_DURATION = 6000;
    const MAX_VISIBLE = 3;

    const cohr = (window.cohr = window.cohr || {});

    /* Motion comes from the token layer, which zeroes itself under
       `prefers-reduced-motion: reduce`. Reading it here rather than hard-coding a number means
       the exit delay follows the token and collapses to 0 with it — and a 0ms transition never
       fires `transitionend`, which is why this is a timeout and not a listener. */
    function motionMs(element) {
      const value = getComputedStyle(element).getPropertyValue('--duration-base');
      const ms = parseFloat(value);
      return isNaN(ms) ? 0 : ms;
    }

    function dismiss(toast) {
      if (!toast || toast.dataset.leaving) return;
      toast.dataset.leaving = 'true';
      if (toast.timer) clearTimeout(toast.timer);
      toast.classList.add('toast--leaving');
      setTimeout(function () {
        toast.remove();
      }, motionMs(toast));
    }

    function startTimer(toast, duration) {
      if (!duration) return;
      toast.timer = setTimeout(function () {
        dismiss(toast);
      }, duration);
    }

    function toast(options) {
      const settings = options || {};
      if (!settings.message) return null;

      const tone = TONES.indexOf(settings.tone) === -1 ? 'neutral' : settings.tone;
      const action = settings.action;

      /* A toast carrying an action must not time out from under the hand reaching for it, so
         the default becomes "stays". An explicit `duration` still wins. */
      let duration = settings.duration;
      if (duration === undefined) duration = action ? 0 : DEFAULT_DURATION;

      const element = template.content.firstElementChild.cloneNode(true);
      element.classList.remove('toast--neutral');
      element.classList.add('toast--' + tone);

      element.querySelectorAll('.toast__glyph').forEach(function (glyph) {
        if (!glyph.classList.contains('toast__glyph--' + tone)) glyph.remove();
      });

      element.querySelector('[data-toast-message]').textContent = settings.message;

      const actionButton = element.querySelector('[data-toast-action]');
      if (action && action.label) {
        actionButton.textContent = action.label;
        actionButton.addEventListener('click', function () {
          if (typeof action.onClick === 'function') action.onClick();
          dismiss(element);
        });
      } else {
        /* Removed rather than hidden: `hidden` is a UA rule at zero specificity and the
           `display: inline-flex` above would defeat it. */
        actionButton.remove();
      }

      element.querySelector('[data-toast-dismiss]').addEventListener('click', function () {
        dismiss(element);
      });

      /* WCAG 2.2.1: a message being read or acted on must not disappear. Pointer and focus are
         both tracked, so a keyboard reader tabbing to the action gets the same reprieve. */
      element.addEventListener('pointerenter', function () {
        if (element.timer) clearTimeout(element.timer);
      });
      element.addEventListener('focusin', function () {
        if (element.timer) clearTimeout(element.timer);
      });
      element.addEventListener('pointerleave', function () {
        startTimer(element, duration);
      });
      element.addEventListener('focusout', function () {
        if (!element.contains(document.activeElement)) startTimer(element, duration);
      });

      host.appendChild(element);

      const live = host.querySelectorAll('[data-toast]:not([data-leaving])');
      for (let i = 0; i < live.length - MAX_VISIBLE; i++) {
        dismiss(live[i]);
      }

      startTimer(element, duration);
      return element;
    }

    cohr.toast = toast;
    cohr.dismissToast = dismiss;
  })();
  } catch(e) { console.error(e); }
})();

})();
